import { render, staticRenderFns } from "./LangPanel.vue?vue&type=template&id=b19e15b6&scoped=true&"
import script from "./LangPanel.vue?vue&type=script&lang=js&"
export * from "./LangPanel.vue?vue&type=script&lang=js&"
import style0 from "./LangPanel.less?vue&type=style&index=0&id=b19e15b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19e15b6",
  null
  
)

export default component.exports